import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import Placeholder from 'Components/Placeholder';

import Text from 'Components/Text';
import Label from 'Components/Label';

registerBlockType('eformv4/trackback', {
	title: __('Single Submission Trackback - eForm', 'ipt_fsqm'),
	icon: 'admin-users',
	category: 'eform-v4',
	attributes: {
		...eFormGTB.attributes.trackback,
	},

	edit({ attributes, className, setAttributes }) {
		const title = __('Single Submission Trackback', 'ipt_fsqm');
		const message = __(
			'A page from where user can see submission data based on trackback id',
			'ipt_fsqm'
		);
		const { label, submit } = attributes;

		return (
			<Placeholder className={className} title={title} message={message}>
				<Label title={__('Track code input label', 'ipt_fsqm')}>
					<Text
						value={label}
						onChange={e => {
							setAttributes({ label: e.target.value });
						}}
					/>
				</Label>
				<Label title={__('Submit button label', 'ipt_fsqm')}>
					<Text
						value={submit}
						onChange={e => {
							setAttributes({ submit: e.target.value });
						}}
					/>
				</Label>
			</Placeholder>
		);
	},

	save() {
		return null;
	},
});
